const permission = {
  admin: {
    orders: {
      routes: ['orders', 'edit_order', 'detail_order'],
      functions: ['export'],
    },
    customers: {
      routes: ['customers', 'detail_customer'],
      functions: ['delete', 'csv'],
    },
    suppliers: {
      routes: ['suppliers', 'create_supplier', 'detail_supplier'],
      functions: ['vendor_selector'],
    },
    vendors: {
      routes: ['vendors', 'create_vendor', 'detail_vendor'],
      functions: [''],
    },
    contacts: {
      routes: ['contacts'],
      functions: [''],
    },
    collections: {
      routes: ['collections', 'create_collection', 'detail_collection'],
      functions: [''],
    },
    schools: {
      routes: ['schools', 'create_school', 'detail_school'],
      functions: [''],
    },
    products: {
      routes: ['products', 'create_product', 'detail_product'],
      functions: [''],
    },
    faqs: {
      routes: ['faqs', 'create_faq', 'detail_faq'],
      functions: [''],
    },
    setting: {
      routes: ['setting'],
      functions: [''],
    },
    transports: {
      routes: ['transports', 'create_transport', 'detail_transport', 'create_transport_fee', 'update_transport_fee'],
      functions: [''],
    },
    specs: {
      routes: ['specs', 'create_spec', 'detail_spec'],
      functions: [''],
    },
    logs: {
      routes: ['email-logs'],
      functions: [''],
    },
    sizes: {
      routes: ['mysize_setting'],
      functions: [''],
    },
    admins: {
      routes: ['edit_admin'],
      functions: [''],
    },
    pages: {
      routes: ['privacy-policy', 'terms-of-use', 'return-policy', 'commercial-transaction-law', 'how-to-buy', 'how-to-cancel-spam', 'external-characters'],
      functions: [''],
    },
  },
  vendor: {
    orders: {
      routes: ['orders', 'edit_order', 'detail_order'],
      functions: ['export'],
    },
    customers: {
      routes: ['customers', 'detail_customer'],
      functions: ['delete', 'csv'],
    },
    suppliers: {
      routes: ['suppliers', 'create_supplier', 'detail_supplier'],
      functions: [],
    },
    vendors: {
      routes: ['vendors', 'detail_vendor'],
      functions: [''],
    },
    contacts: {
      routes: ['contacts'],
      functions: [''],
    },
    collections: {
      routes: ['collections', 'create_collection', 'detail_collection'],
      functions: [''],
    },
    schools: {
      routes: ['schools', 'create_school', 'detail_school'],
      functions: [''],
    },
    products: {
      routes: ['products', 'create_product', 'detail_product'],
      functions: [''],
    },
    setting: {
      routes: ['setting'],
      functions: [''],
    },
    transports: {
      routes: ['transports', 'create_transport', 'detail_transport', 'create_transport_fee', 'update_transport_fee'],
      functions: [''],
    },
    specs: {
      routes: ['specs', 'create_spec', 'detail_spec'],
      functions: [''],
    },
    logs: {
      routes: ['email-logs'],
      functions: [''],
    },
    sizes: {
      routes: ['mysize_setting'],
      functions: [''],
    },
  },
};

export default permission;
